
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/max-return",
      function () {
        return require("private-next-pages/max-return.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/max-return"])
      });
    }
  